import type { Selector } from "@reduxjs/toolkit";
import { createSelector } from "@reduxjs/toolkit";

import type { IRfqTransaction } from "@/shop/types/shopping/rfq";

import type { IRfqListReducerState } from "./types";
import type { IShopRootState } from "../../../types";

const getRfqListState: Selector<IShopRootState, IRfqListReducerState> = (state) => state.shopping.rfqList;

export const getRfqList: Selector<IShopRootState, IRfqTransaction[]> = createSelector(getRfqListState, (state) => state.rfqList);

export const getRfqListIsFetching = createSelector(getRfqListState, (state) => state.isFetching);

export const getRfqListHasError = createSelector(getRfqListState, (state) => state.hasError);
